module.exports = __webpack_public_path__ + "static/3-001-a36007cbe0533ed347dbf595a19b7e1a.png";